"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "broadcastSyncedServerTime", {
  enumerable: true,
  get: function get() {
    return _broadcastSyncedServerTime["default"];
  }
});
var _broadcastSyncedServerTime = _interopRequireDefault(require("./broadcastSyncedServerTime"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }